<template>
    <div class="box mv_reservation_form">
        <h2><font-awesome-icon @click="$root.$emit('hidePopup')" icon="arrow-left" style="font-size: 24px;vertical-align:middle" /> Nuova Prenotazione</h2>
        <p>Inserisci i tuoi dati per prenotare da {{$store.state.shopInfo.name}}</p>
        <form @submit.prevent="sendReservation">
            <div class="left">
                <div class="input-group">
                <div >
                <label for="">Nome</label>
                <input type="text" name="" id="" v-model="name">
                </div>
                <div>
                <label for="">Cognome</label>
                <input type="text" name="" id="" v-model="surname">
                </div>
            </div>
            <label for="">Numero di Telefono</label>
            <input type="text" name="" id="" v-model="phoneNumber">
            <label for="">Indirizzo Email</label>
            <input type="email" name="" id="" v-model="emailAddress">

            
            <div class="input-group">
                <div >
                <label for="">A che ora?</label>
                <input type="time" v-model="time">
                </div>
                <div>
                <label for="">Quante persone?</label>
                <input type="number" min="1" name="" id="" v-model="numberOfPeople">
                </div>
            </div>
            </div>
            <div class="right">
                <label style="margin-top:0" for="">Quando?</label>
                <date-picker style="width:100%" v-model="date" is-inline :min-date="new Date()"/>

                <div class="fixed">
                     <button class="btn btn-primary my-4 btn-lg">Richiedi Prenotazione</button>
                <small style="opacity:.5">Riceverai la conferma della tua prenotazione direttamente nella tua mail.</small>
                </div>
               

            </div>
            
        </form>
    </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import 'vue2-timepicker/dist/VueTimepicker.css'
import {formatISO} from 'date-fns'
import CompleteReservationVue from './CompleteReservation.vue'
export default {
    data() {
        return {
            name: '',
            surname: '',
            emailAddress: '',
            phoneNumber: '',
            date: null,
            time: null,
            numberOfPeople: 1
        }
    },
    computed: {
        input(){
            let date = this.date;
            let dividedTime = {
                HH: parseInt(this.time.split(':')[0]),
                mm: parseInt(this.time.split(':')[1])
            }
            date.setHours(dividedTime.HH,dividedTime.mm);
            return {
                name: this.name,
                surname: this.surname,
                emailAddress: this.emailAddress,
                phoneNumber: this.phoneNumber,
                reservationDate: formatISO(date),
                numberOfPeople: this.numberOfPeople
            }
        }
    }, 
    methods: {
        async sendReservation(){
            let reservation = await this.$store.dispatch('createReservation',this.input);
            this.$root.$emit('popup',{component: CompleteReservationVue, componentData: {reservationNumber: reservation.reservation.reservationNumber}})
        }
    },
    components: {
        DatePicker
    }
}
</script>

<style lang="scss" scoped>
    .mv_reservation_form {
        width: 90vw;
        max-width: 1000px;
        box-sizing:border-box;
        padding: 1em;
        
    }
    form {
        display: grid;
        grid-template-columns: repeat(2,1fr);
        grid-gap: 2em;
        width: 100%;

        @media screen and (max-width: 768px) {
            grid-template-columns: none;
        }

        .left, .right {
            display: flex;
            flex-direction: column;
            flex:1
        }
        
        .input-group {
            display: grid;
            grid-template-columns: repeat(2,1fr);
            grid-gap: 1em;
            input {
                width: 100%;
            }

        }
    }
    label {
            font-weight: 600;
            margin: 1em 0;
        }

@media screen and (max-width: 768px) {

         .fixed {
             z-index: 1;
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            width: 100vw;
            margin-left: -1em;
            box-sizing: border-box;
            padding: 1em;
            background-color: rgba(255, 255, 255, 0.9);
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

}

</style>